<div class="custome-tab">
  <div class="op-tabs">
    <button
      type="button"
      class="op-tab"
      [class.active]="activeTabLabel === tabLabel.OpenPositions"
      (click)="selectTab(tabLabel.OpenPositions)"
    >Open positions <span class="op-badge">{{ positionCount }}</span></button>
    <button
      type="button"
      class="op-tab"
      [class.active]="activeTabLabel === tabLabel.Candidates"
      (click)="selectTab(tabLabel.Candidates)"
    >Candidates <span class="op-badge">{{ candidatesCount }}</span></button>
  </div>

  <div class="search-bar-container" *ngIf="activeTabLabel === tabLabel.OpenPositions">
    <div class="op-search">
      <i class="material-icons op-search-ic">search</i>
      <input
        type="text"
        [value]="filterValue"
        (keyup)="searchItem($event)"
        placeholder="Search open positions…"
        aria-label="Search open positions"
      />
      <button
        *ngIf="filterValue?.length && filterValue.length > 0"
        class="op-search-clear"
        (click)="clearInput()"
        aria-label="Clear search"
      >✕</button>
    </div>
    <app-open-position-filter [fieldsVisibility]="fieldsVisibility"
      (myOutput)="handleDataFromChild($event)"></app-open-position-filter>
  </div>

  <div class="openposition-table" *ngIf="activeTabLabel === tabLabel.OpenPositions">
    <ng-container *ngIf="displayData?.length">
      <div class="op-table-wrap">
        <table class="op-table opos-table">
          <thead>
            <tr>
              <th class="sortable" (click)="sortBy('hiringRequestId')">Position ID <span class="op-sort" [class.asc]="sortField === 'hiringRequestId' && sortDir === 'asc'" [class.desc]="sortField === 'hiringRequestId' && sortDir === 'desc'"></span></th>
              <th class="sortable" (click)="sortBy('jobTitle')">Job Title <span class="op-sort" [class.asc]="sortField === 'jobTitle' && sortDir === 'asc'" [class.desc]="sortField === 'jobTitle' && sortDir === 'desc'"></span></th>
              <th class="sortable c" (click)="sortBy('numberOfPositions')">Positions <span class="op-sort" [class.asc]="sortField === 'numberOfPositions' && sortDir === 'asc'" [class.desc]="sortField === 'numberOfPositions' && sortDir === 'desc'"></span></th>
              <th class="sortable" (click)="sortBy('lobName')">LoB <span class="op-sort" [class.asc]="sortField === 'lobName' && sortDir === 'asc'" [class.desc]="sortField === 'lobName' && sortDir === 'desc'"></span></th>
              <th class="sortable" (click)="sortBy('dntLeaderName')">ID&T Leader <span class="op-sort" [class.asc]="sortField === 'dntLeaderName' && sortDir === 'asc'" [class.desc]="sortField === 'dntLeaderName' && sortDir === 'desc'"></span></th>
              <th class="sortable" (click)="sortBy('createdDate')">Opened Date <span class="op-sort" [class.asc]="sortField === 'createdDate' && sortDir === 'asc'" [class.desc]="sortField === 'createdDate' && sortDir === 'desc'"></span></th>
              <th class="sortable c" (click)="sortBy('ageOld')">Aging <span class="op-sort" [class.asc]="sortField === 'ageOld' && sortDir === 'asc'" [class.desc]="sortField === 'ageOld' && sortDir === 'desc'"></span></th>
              <th class="sortable" (click)="sortBy('vendorName')">Shared by Vendor <span class="op-sort" [class.asc]="sortField === 'vendorName' && sortDir === 'asc'" [class.desc]="sortField === 'vendorName' && sortDir === 'desc'"></span></th>
              <th class="sortable" (click)="sortBy('desiredStartDate')">Desired Start Date <span class="op-sort" [class.asc]="sortField === 'desiredStartDate' && sortDir === 'asc'" [class.desc]="sortField === 'desiredStartDate' && sortDir === 'desc'"></span></th>
              <th class="sortable" (click)="sortBy('location')">Location <span class="op-sort" [class.asc]="sortField === 'location' && sortDir === 'asc'" [class.desc]="sortField === 'location' && sortDir === 'desc'"></span></th>
              <th>Comments</th>
              <th class="sortable" (click)="sortBy('status')">Request Status <span class="op-sort" [class.asc]="sortField === 'status' && sortDir === 'asc'" [class.desc]="sortField === 'status' && sortDir === 'desc'"></span></th>
              <th class="sortable c" (click)="sortBy('noOfCandidates')">Profiles Received <span class="op-sort" [class.asc]="sortField === 'noOfCandidates' && sortDir === 'asc'" [class.desc]="sortField === 'noOfCandidates' && sortDir === 'desc'"></span></th>
              <th class="c">Job Description</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let v of pagedData">
              <td class="mono">{{ v.hiringRequestId }}</td>
              <td>
                <span class="op-jt-wrap">
                  <i *ngIf="v.isPriority?.toString() === 'true'" class="material-icons op-jt-flag" title="Critical priority">flag</i>
                  <a class="op-jt" (click)="navigateToJobDetails(v)" [attr.title]="v.jobTitle || null">{{ v.jobTitle }}</a>
                </span>
              </td>
              <td class="c mono">{{ v.numberOfPositions ?? '—' }}</td>
              <td [attr.title]="v.lobName || null">{{ v.lobName || '—' }}</td>
              <td [attr.title]="v.dntLeaderName || null">{{ v.dntLeaderName || '—' }}</td>
              <td>{{ v.createdDate | date: dateFormat.Month }}</td>
              <td class="c mono">{{ v.ageOld ?? '—' }}</td>
              <td [attr.title]="v.vendorName || null">{{ v.vendorName || '—' }}</td>
              <td>{{ v.desiredStartDate | date: dateFormat.Month }}</td>
              <td [attr.title]="v.location || null">{{ v.location || '—' }}</td>
              <td [attr.title]="v.additionalComments || null">{{ v.additionalComments || '—' }}</td>
              <td>
                <span class="op-pill" [ngClass]="statusTone(v.status)" *ngIf="v.status">
                  <span class="dot"></span>{{ v.status }}
                </span>
              </td>
              <td class="c mono">{{ v.noOfCandidates ?? '—' }}</td>
              <td class="c">
                <button
                  *ngIf="v.jobDescriptionPath"
                  class="ts-iconbtn"
                  title="Download job description"
                  (click)="downloadFile(v.jobDescriptionPath, v.jobTitle, 'Job_Description')"
                ><i class="material-icons">download</i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="op-tfoot">
        <div class="op-info">
          Showing <b>{{ rangeStart }}–{{ rangeEnd }}</b> of <b>{{ displayData.length }}</b> open positions
        </div>
        <div class="op-pager">
          <button class="pg" (click)="prevPage()" [disabled]="pageIndex === 1" aria-label="Previous page">‹</button>
          <button
            *ngFor="let pnum of pageWindow; trackBy: trackByIndex"
            class="pg"
            [class.on]="pnum === pageIndex"
            [disabled]="pnum === -1"
            (click)="goToPage(pnum)"
          >{{ pnum === -1 ? '…' : pnum }}</button>
          <button class="pg" (click)="nextPage()" [disabled]="pageIndex >= totalPages" aria-label="Next page">›</button>
        </div>
        <div class="op-psize">
          <span>Rows</span>
          <select [value]="pageSize" (change)="onPageSizeChange($event)" aria-label="Rows per page">
            <option [value]="10">10</option>
            <option [value]="25">25</option>
            <option [value]="50">50</option>
          </select>
        </div>
      </div>
    </ng-container>
  </div>
  <section class="records-container" aria-label="Records section" *ngIf="
      activeTabLabel === tabLabel.OpenPositions &&
      isDataLoaded &&
      displayData.length === 0
    ">
    <div class="empty-state">
      <h2 class="empty-state-title">No Records Found</h2>
      <img [src]="imageSrc" alt="No records illustration" class="empty-state-image" />
    </div>
  </section>
  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>
  <app-ops-candidates *ngIf="activeTabLabel === tabLabel.Candidates" (candidatesCountChange)="onCandidatesCountChange($event)"></app-ops-candidates>
  <app-modal-wrapper *ngIf="showJobDetails" [showModal]="showJobDetails">
    <app-ops-job-details
      [openPositionData]="selectedJob"
      (close)="showJobDetails = false"
    ></app-ops-job-details>
  </app-modal-wrapper>
</div>
